import * as React from 'react';
import type { RadioButtonsGroupProps } from '@components/moleculs/radio-group/types';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled } from 'styled-components';

import { FormControl } from './styles';

const Molecule: React.FC<RadioButtonsGroupProps> = ({
    id,
    label,
    options,
    defaultValue,
    value,
    onChange,
    className,
    disabled,
}) => (
    <FormControl className={className}>
        {label && <FormLabel id={id}>{label}</FormLabel>}
        <RadioGroup
            aria-labelledby={id}
            defaultValue={defaultValue}
            name={`${id}-group`}
            onChange={onChange}
            value={value}
        >
            {options?.map((radioControl) => (
                <FormControlLabel
                    disabled={disabled}
                    key={radioControl.value}
                    value={radioControl.value}
                    control={<Radio />}
                    label={radioControl.label}
                />
            ))}
        </RadioGroup>
    </FormControl>
);

export const RadioButtonsGroup = styled(Molecule)({});
